module.exports = __webpack_public_path__ + "e074389f9b3f2eb39fa82dba350a20d7.svg";